import index from "@/views/Index-main";
import home from "@/views/Index-home";
import elecboard from "@/views/Index-elecBoard";
import activation from "@/views/Index-activation";
import operatelog from "@/views/Index-operateLog";
import errorhistory from "@/views/Index-errorHistory";
import workorderhistory from "@/views/Index-workOrderHistory";
import ordermanagement from "@/views/Index-orderManagement";
import devicemanagement from "@/views/Index-deviceManagement";
import permissionsetting from "@/views/Index-permissionSetting";
import permissionmanagement from "@/views/Index-permissionManagement";
import heatinstant from "@/views/Index-heatInstant";
import statisticalreports from "@/views/Index-statisticalReports";
import homemap from "@/views/Index-homeMap";
import schedulecalculation from "@/views/Index-scheduleCalculation";
import heatalarmsetting from "@/views/Index-heatAlarmSetting";

export const childRouter = [
  {
    path: "/index",
    name: "index",
    redirect: "/index/home",//登入位置
    component: index,
    children: [
      { path: "home", name: "home", component: home, meta: { needLogin: true } },
      { path: "elecboard", name: "elecboard", component: elecboard, meta: { needLogin: true } },
      { path: "activation", name: "activation", component: activation, meta: { needLogin: true } },
      { path: "operatelog", name: "operatelog", component: operatelog, meta: { needLogin: true } },
      { path: "errorhistory", name: "errorhistory", component: errorhistory, meta: { needLogin: true } },
      { path: "workorderhistory", name: "workorderhistory", component: workorderhistory, meta: { needLogin: true } },
      { path: "ordermanagement", name: "ordermanagement", component: ordermanagement, meta: { needLogin: true } },
      { path: "devicemanagement", name: "devicemanagement", component: devicemanagement, meta: { needLogin: true } },
      { path: "permissionsetting", name: "permissionsetting", component: permissionsetting, meta: { needLogin: true } },
      { path: "permissionmanagement", name: "permissionmanagement", component: permissionmanagement, meta: { needLogin: true } },
      { path: "heatinstant", name: "heatinstant", component: heatinstant, meta: { needLogin: true } },
      { path: "statisticalreports", name: "statisticalreports", component: statisticalreports, meta: { needLogin: true } },
      { path: "homemap", name: "homemap", component: homemap, meta: { needLogin: true } },
      { path: "schedulecalculation", name: "schedulecalculation", component: schedulecalculation, meta: { needLogin: true } },
      { path: "heatalarmsetting", name: "heatalarmsetting", component: heatalarmsetting, meta: { needLogin: true } },
    ]
  },
];
